module.exports = __webpack_public_path__ + "img/personal.9905c464.png";